
import './App.css';
import PortfolioContainer from './PortfolioContainer/PortfolioContainer';
import React from 'react';
import Header from './PortfolioContainer/Home/Header/Header';
import './i18n';


function App() {
  return ( <div className="App">
    <PortfolioContainer/>
  </div>
  );
}
export default App;
